import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
// extend dayjs to support UTC parsing
dayjs.extend(utc);

import { FormError, HelpText } from '@Forms/fields.jsx';

const handleFocus = (e) => {
  // disable text input/changing within field, only via datepicker
  //
  // based on this example: https://stackoverflow.com/a/78204489/130715
  if (e.target) {
    e.target.readOnly = true; // -------> this for all others
    e.target.blur(); //  ------> this for ios iphone, TV Browsers, Ipad, Safari
  }
};

const DateTimeField = (props) => {
  // field to set a date and time in format of YYYY-MM-DD HH:mm:ss

  return (
    <div
      className={
        `sb-form-item-formgroup sb-form-item-input ` +
        (props.error ? 'sb-form-item-error' : '')
      }
    >
      <label htmlFor={props.field.name}>{props.label}</label>
      <div className="sb-form-item-content">
        <DatePicker
          placeholderText="Select date and time"
          aria-invalid={props.error ? 'true' : 'false'}
          selected={
            props.value
              ? dayjs.utc(props.value).local().format('YYYY-MM-DD HH:mm:ss')
              : null
          }
          isClearable={props.isClearable}
          showTimeInput
          dateFormat="M/dd/yyyy h:mm aa"
          timeInputLabel="Time:"
          onChange={(day) => {
            if (!day) {
              // cleared day
              return props.field.onChange(day);
            }
            return props.field.onChange(
              dayjs(day).utc().format('YYYY-MM-DD HH:mm:ss'),
            );
          }}
          onFocus={handleFocus}
        />
        {props.helpText && <HelpText message={props.helpText} />}
        {props.error && <FormError message={props.error.message} />}
      </div>
    </div>
  );
};

export default DateTimeField;
